function normalizeText(value: unknown): string {
   return String(value ?? "").trim().toLowerCase();
}

function getPropertyCaseInsensitive(properties: Record<string, unknown>, key: string): unknown {
   const direct = properties[key];
   if (direct !== undefined) return direct;
   const lowerKey = key.toLowerCase();
   const realKey = Object.keys(properties).find((propertyKey) => propertyKey.toLowerCase() === lowerKey);
   return realKey ? properties[realKey] : undefined;
}

/**
 * Jupiter keeps virktypt as Markvanding after a well is sløjfet.
 * kode V is the current-use category: a water well still in operation.
 */
export function isMarkvandingWell(feature: { properties?: Record<string, unknown> } | null | undefined): boolean {
   const properties = feature?.properties ?? {};
   const value = normalizeText(getPropertyCaseInsensitive(properties, "virktypt"));
   const isMarkvanding = value.split(/[;,]/).map((item) => item.trim()).includes("markvanding");
   if (!isMarkvanding) return false;
   return normalizeText(getPropertyCaseInsensitive(properties, "kode")) === "v";
}
